import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { Observable } from 'rxjs'

import {
  Enumeration,
  EnumerationParams,
  EnumerationsContents,
} from '@flowx/designer/shared/entities/enumeration.entity'

import { ApiHttpProxyService, ForwardProxyMicroservice } from './api-http-proxy.service'

import { ApplicationResourceType, ProxyApiAction } from '../entities/application.entity'
import { ImportResourceSessionResponse } from '../entities/existing-resource.entity'

export const resourceTypeToForwardProxyMicroservice = {
  [ApplicationResourceType.Enumeration]: ForwardProxyMicroservice.Cms,
  [ApplicationResourceType.Substitutiontag]: ForwardProxyMicroservice.Cms,
  [ApplicationResourceType.Process]: ForwardProxyMicroservice.Admin,
  [ApplicationResourceType.Hook]: ForwardProxyMicroservice.TaskManager,
  [ApplicationResourceType.Stages]: ForwardProxyMicroservice.TaskManager,
  [ApplicationResourceType.Allocation]: ForwardProxyMicroservice.TaskManager,
  [ApplicationResourceType.System]: ForwardProxyMicroservice.Integration,
  [ApplicationResourceType.Workflow]: ForwardProxyMicroservice.Integration,
  [ApplicationResourceType.ReusableTemplate]: ForwardProxyMicroservice.Admin,
  [ApplicationResourceType.CustomComponent]: ForwardProxyMicroservice.Admin,
  [ApplicationResourceType.UiFlow]: ForwardProxyMicroservice.Admin,
  [ApplicationResourceType.ProxyConnection]: ForwardProxyMicroservice.Integration,
}

@Injectable({
  providedIn: 'root',
})
export class ImportExportApiService extends ApiHttpProxyService {
  import(
    formData: FormData,
    resourceType: ApplicationResourceType
  ): Observable<ImportResourceSessionResponse> {
    return this.postMultipart(null, formData, {
      microservice: resourceTypeToForwardProxyMicroservice[resourceType],
      action: ProxyApiAction.IMPORT,
      resourceType,
    })
  }

  export(
    payload: { resourcesIds: string[] },
    resourceType: ApplicationResourceType
  ): Observable<Blob> {
    return this.post(`api/rt/${resourceType}/export`, payload, {
      microservice: resourceTypeToForwardProxyMicroservice[resourceType],
      action: ProxyApiAction.EXPORT,
      resourceType,
      responseType: 'blob',
    })
  }

  importCsv(
    resourceType: ApplicationResourceType,
    enumerationsContents: EnumerationsContents
  ): Observable<{
    importFailed: object
    importSuccess: [string]
  }> {
    const { appId, appVersionId } = this.urlParametersStoreService.urlParameters

    return this.httpClient.post<{
      importFailed: object
      importSuccess: [string]
    }>(
      `${this.getProxyBaseUrl(appId, appVersionId)}/import/rt/${resourceType}/csv`,
      enumerationsContents
    )
  }

  exportCsv(
    resourceType: ApplicationResourceType,
    params?: Partial<EnumerationParams>
  ): Observable<Enumeration[]> {
    const { appId, appVersionId } = this.urlParametersStoreService.urlParameters

    return this.httpClient.get<Enumeration[]>(
      `${this.getProxyBaseUrl(appId, appVersionId)}/export/rt/${resourceType}/csv`,
      {
        params: params ? this.addParams(params) : ({} as HttpParams),
      }
    )
  }

  resumeImport(data: ImportResourceSessionResponse): Observable<void> {
    const { appId, appVersionId } = this.urlParametersStoreService.urlParameters
    return this.httpClient.post<void>(
      `${this.getProxyBaseUrl(appId, appVersionId)}/import/session/resume`,
      data
    )
  }

  abortImport(sessionId: string): Observable<void> {
    const { appId, appVersionId } = this.urlParametersStoreService.urlParameters
    return this.httpClient.post<void>(
      `${this.getProxyBaseUrl(appId, appVersionId)}/import/session/${sessionId}/abort`,
      {}
    )
  }
}
